export const HOURS_STEP = 30; // In minutes
export const AVAILABLE_MEETING_LENGTHS = [60, 90, 120] as const;

export const MEETING_HOUR_OPTION_START = '09:00';
export const MEETING_HOUR_OPTION_END = '16:00';
